module.exports = __webpack_public_path__ + "img/dischargeMgt.9ed5558e.svg";